import type { UploadJob } from '@/shared/domain'
import { UploadTrayCard } from './upload-tray-card'

export type UploadTrayProps = {
  jobs: UploadJob[]
  onCancel: (jobId: string) => void
  onRetry: (jobId: string) => void
  onDismiss: (jobId: string) => void
}

export function UploadTray({ jobs, onCancel, onRetry, onDismiss }: UploadTrayProps) {
  if (jobs.length === 0) return null

  return (
    <div className="fixed bottom-6 right-6 z-50 flex w-80 max-w-[calc(100vw-3rem)] flex-col gap-2">
      {jobs.map((job) => (
        <UploadTrayCard
          key={job.id}
          job={job}
          onCancel={onCancel}
          onRetry={onRetry}
          onDismiss={onDismiss}
        />
      ))}
      <p className="px-1 text-xs text-muted-foreground">
        Uploads stop if you close or reload the tab.
      </p>
    </div>
  )
}
